import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=0afda168&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=0afda168&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afda168",
  null
  
)

export default component.exports